import { FormControl, FormHelperText, FormLabel, Stack } from '@mui/material';
import { RichTextEditor, type RichTextEditorRef } from 'components/RichTextEditor';
import type { FC, RefObject } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

type Props = {
  name: string;
  label?: string;
  placeholder?: string;
  helperText?: string;
  editorRef?: RefObject<RichTextEditorRef | null>;
};

export const RHFRichTextEditor: FC<Props> = ({
  name,
  label,
  placeholder,
  helperText,
  editorRef,
}) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error} fullWidth>
          {label && <FormLabel sx={{ mb: 0.5 }}>{label}</FormLabel>}
          <Stack
            sx={{
              border: 1,
              borderColor: error ? 'error.main' : 'divider',
              borderRadius: 1,
              p: 1,
              '&:focus-within': {
                borderColor: error ? 'error.main' : 'primary.main',
              },
            }}
          >
            <RichTextEditor
              editorRef={editorRef}
              value={field.value ?? ''}
              onChange={(md) => field.onChange(md === '' ? null : md)}
              placeholder={placeholder}
              ariaLabel={label}
            />
          </Stack>
          {(error?.message || helperText) && (
            <FormHelperText>{error?.message || helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};
